<template>
  <v-hover v-slot="{ hover }">
    <v-card
      color=""
      elevation="1"
      width="220"
      :to="{ name: 'context', params: { contextId: context.id } }"
    >
      <v-img height="100" :src="imageURL" class="grey lighten-3">
        <v-row no-gutters>
          <v-menu :attach="$el">
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                @click.stop.prevent="on.click"
                @keydown="on.keydown"
                @mousedown.stop
                v-show="context.status == 'active' || hover"
                class="shrink"
              >
                <v-icon v-if="context.status == 'active'">star</v-icon>
                <v-icon v-else color="grey darken-1">star_border</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                @click.stop.prevent="
                  updateContextKey({ contextId: context.id, key: 'status', value: 'active' })
                "
              >
                <v-list-item-action><v-icon>star</v-icon></v-list-item-action>
                <v-list-item-title>Active</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click.stop.prevent="
                  updateContextKey({ contextId: context.id, key: 'status', value: 'inactive' })
                "
              >
                <v-list-item-action><v-icon>star_border</v-icon></v-list-item-action>
                <v-list-item-title>In-active</v-list-item-title>
              </v-list-item>
              <!-- <v-list-item  @click="updateContextKey({ contextId: context.id, key: 'status', value: 'active' })">
              <v-list-item-action><v-icon>snooze</v-icon></v-list-item-action>
              <v-list-item-title>Snooze</v-list-item-title>
            </v-list-item> -->
            </v-list>
          </v-menu>
          <v-spacer></v-spacer>
          <v-menu :attach="$el">
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                @click.stop.prevent="on.click"
                @mousedown.stop
                @keydown="on.keydown"
                v-show="hover"
                class="shrink"
              >
                <v-icon color="grey darken-1">more_vert</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click.stop.prevent="">
                <v-list-item-action><v-icon>archive</v-icon></v-list-item-action>
                <v-list-item-title>Archive Context</v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop.prevent="">
                <v-list-item-action><v-icon>close</v-icon></v-list-item-action>
                <v-list-item-title>Permanently Delete</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-row>
      </v-img>
      <v-card-title style="font-size: 16px; line-height: 1.5rem;">
        <slot name="title"></slot>
      </v-card-title>
      <slot name="subtitle"></slot>
    </v-card>
  </v-hover>
</template>

<script>
import useUserSummary from '@/store/useUserSummary';

export default {
  props: ['context'],
  setup() {
    const { updateContextKey } = useUserSummary();
    return { updateContextKey };
  },
  data() {
    return {
      imageURL: ''
    };
  }
};
</script>

<style></style>
